import { Component, OnInit } from '@angular/core';
import { AuthService } from '@portal/app/shared/services/auth.service';

@Component({
  selector: 'portal-logout',
  template: `
    <div class="logout-container">
      <div class="logout-message">
        <h2>Logging Out</h2>
        <p>Thank you for using Measured Portal!</p>
      </div>
    </div>
  `,
  styles: [
    `
      .logout-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        background-color: #f5f5f5;
      }

      .logout-message {
        text-align: center;
        padding: 2rem;
        background-color: white;
        border-radius: 8px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      }

      h2 {
        color: #333;
        margin-bottom: 1rem;
      }

      p {
        color: #666;
        margin: 0;
      }
    `
  ]
})
export class LogoutComponent implements OnInit {
  constructor(private readonly authService: AuthService) {}

  ngOnInit(): void {
    this.authService.logout();
  }
}
